<ng-container *transloco="let convert;">
  @if (auctionItem$ | async; as auctionItem) {
    <div class="auction-detail">
      <h2 class="auction-detail__openingPrice">
        @if (!soldVehicle) {
          @if (auctionItem.openingPrice) {
            <span>{{ convert('sellModule.details.auctionDetail.textOpeningPrice') }}
            </span>
          }
          @if (!auctionItem.openingPrice) {
            <span>{{ convert('sellModule.details.auctionDetail.currentBid') }} </span>
          }
          <span class="auction-detail__openingPrice--amount">&nbsp;{{ formatCurrency(auctionItem.currentAmount) }}
          </span>
          @if (!auctionItem.currentAmount) {
            <span class="auction-detail__openingPrice--amount">&nbsp;N/A</span>
          }
          <ng-container>
            @if (auctionItem.lowestPrice) {
<app-tooltip triggers="hover click :keydown.escape :keydown.tab" [tooltip]="{
        metaTitle: convert('sellModule.details.auctionDetail.tooltipLowestPrice.metaTitle'),
        title: convert('sellModule.details.auctionDetail.tooltipLowestPrice.title'),
        body: convert('sellModule.details.auctionDetail.tooltipLowestPrice.body')
        }" [attr.aria-label]="convert('sellModule.details.auctionDetail.tooltipLowestPrice.metaTitle')">
                <img class="low-price-indicator"
                  src="../../../ui/assets/assets-{{ tenantName }}/{{ tenantName }}-low-price-indicator.svg"
                  alt="{{ convert('sellModule.details.auctionDetail.lowestPrice') }}" />
              </app-tooltip>
            }
          </ng-container>
        }
        @if (soldVehicle) {
          <span>{{ convert('sellModule.details.auctionDetail.salePrice') }} </span>
          <span>{{ formatCurrency(auctionItem.salePrice) }}</span>
        }
      </h2>
      <div class="auction-detail__status">
        @if (!soldVehicle) {
          <app-auction-badge text="{{ (auctionItem.buyerAuctionItemStatus | badgeStatus).text }}"
            hasIcon="{{ (auctionItem.buyerAuctionItemStatus | badgeStatus).hasIcon }}"
            outline="{{ (auctionItem.buyerAuctionItemStatus | badgeStatus).outline }}"
            variant="{{ (auctionItem.buyerAuctionItemStatus | badgeStatus).variant }}">
          </app-auction-badge>
        }
        @if (soldVehicle) {
          <app-auction-badge text="{{convert(auctionItem.buyerAuctionItemStatus)}}" variant="success">
          </app-auction-badge>
        }
      </div>
      <div class="auctionTime">
        <ul class="list-unstyled">
          <li class="m-0 spread-to-book">
            <app-datalist-item label="{{convert('sellModule.details.auctionDetail.spreadToBook')}}"
              value="{{ spreadToBookValue ? (spreadToBookValue * 100 | number: '1.0-0') + '%' : 'N/A'}}">
              @if (spreadToBookValue) {
                <app-tooltip [tooltip]="spreadToBookTooltip" triggers="click :keydown.escape :keydown.tab"
                  >
                  <i class="allycon-info-outline text-primary" aria-hidden="true"></i>
                </app-tooltip>
              }
            </app-datalist-item>
          </li>
          @if (!soldVehicle) {
            <li class="m-0">
              @if (showAuctionStartTime) {
                <app-datalist-item label="{{convert('sellModule.details.auctionDetail.startDateTime')}}"
                  identifier="active_vdp_start_date">
                  <time class="auction_time">{{ auctionStartTime }}</time>
                  <span>
                    @switch (isMobile) {
                      @case (true) {
                        <span>
                          @if (auctionItem.firstDay) {
                            <app-tooltip
                              [tooltip]="{ title: convert('sellModule.details.auctionDetail.tooltipTimeIndicator.title'), body: convert('sellModule.details.auctionDetail.tooltipTimeIndicator.body') }"
                              triggers="click :keydown.escape :keydown.tab">
                              <div class="tooltip-letter bg-dark text-white"
                                [attr.aria-label]="convert('sellModule.details.auctionDetail.tooltipTimeIndicator.ariaLabelFirstDay')">
                                <span aria-hidden="true">F</span>
                              </div>
                            </app-tooltip>
                          }
                        </span>
                      }
                      @case (false) {
                        <span>
                          @if (auctionItem.firstDay) {
                            <app-tooltip
                              [tooltip]="{ title: convert('sellModule.details.auctionDetail.tooltipTimeIndicator.title'), body: convert('sellModule.details.auctionDetail.tooltipTimeIndicator.body') }"
                              triggers="click hover :keydown.escape :keydown.tab">
                              <div class="tooltip-letter bg-dark text-white"
                                [attr.aria-label]="convert('sellModule.details.auctionDetail.tooltipTimeIndicator.ariaLabelFirstDay')">
                                <span aria-hidden="true">F</span>
                              </div>
                            </app-tooltip>
                          }
                        </span>
                      }
                      @default {
                        <span>
                          @if (auctionItem.firstDay) {
                            <app-tooltip
                              [tooltip]="{ title: convert('sellModule.details.auctionDetail.tooltipTimeIndicator.title'), body: convert('sellModule.details.auctionDetail.tooltipTimeIndicator.body') }"
                              triggers="click hover :keydown.escape :keydown.tab">
                              <div class="tooltip-letter bg-dark text-white"
                                [attr.aria-label]="convert('sellModule.details.auctionDetail.tooltipTimeIndicator.ariaLabelFirstDay')">
                                <span aria-hidden="true">F</span>
                              </div>
                            </app-tooltip>
                          }
                        </span>
                      }
                    }
                  </span>
                </app-datalist-item>
              }
              @if (showAuctionEndTime) {
                <app-datalist-item label="{{convert('sellModule.details.auctionDetail.endDateTime')}}"
                  identifier="active_vdp_end_date">
                  <time class="auction_time">{{ auctionEndTime }}</time>
                  <span>
                    @switch (isMobile) {
                      @case (true) {
                        <span>
                          @if (auctionItem.firstDay) {
                            <app-tooltip
                              [tooltip]="{ title: convert('sellModule.details.auctionDetail.tooltipTimeIndicator.title'), body: convert('sellModule.details.auctionDetail.tooltipTimeIndicator.body') }"
                              triggers="click :keydown.escape :keydown.tab">
                              <div class="tooltip-letter bg-dark text-white"
                                [attr.aria-label]="convert('sellModule.details.auctionDetail.tooltipTimeIndicator.ariaLabelFirstDay')">
                                <span aria-hidden="true">F</span>
                              </div>
                            </app-tooltip>
                          }
                        </span>
                      }
                      @case (false) {
                        <span>
                          @if (auctionItem.firstDay) {
                            <app-tooltip
                              [tooltip]="{ title: convert('sellModule.details.auctionDetail.tooltipTimeIndicator.title'), body: convert('sellModule.details.auctionDetail.tooltipTimeIndicator.body') }"
                              triggers="click hover :keydown.escape :keydown.tab">
                              <div class="tooltip-letter bg-dark text-white"
                                [attr.aria-label]="convert('sellModule.details.auctionDetail.tooltipTimeIndicator.ariaLabelFirstDay')">
                                <span aria-hidden="true">F</span>
                              </div>
                            </app-tooltip>
                          }
                        </span>
                      }
                      @default {
                        <span>
                          @if (auctionItem.firstDay) {
                            <app-tooltip
                              [tooltip]="{ title: convert('sellModule.details.auctionDetail.tooltipTimeIndicator.title'), body: convert('sellModule.details.auctionDetail.tooltipTimeIndicator.body') }"
                              triggers="click hover :keydown.escape :keydown.tab">
                              <div class="tooltip-letter bg-dark text-white"
                                [attr.aria-label]="convert('sellModule.details.auctionDetail.tooltipTimeIndicator.ariaLabelFirstDay')">
                                <span aria-hidden="true">F</span>
                              </div>
                            </app-tooltip>
                          }
                        </span>
                      }
                    }
                  </span>
                </app-datalist-item>
              }
              @if (showAuctionExtendTime) {
                <app-datalist-item identifier="active_vdp_extended_date"
                  label="{{convert('sellModule.details.auctionDetail.endDateTime')}}">
                  <time class="auction_time">
                    {{ auctionExtendedTime }}
                  </time>
                  <span>
                    @switch (isMobile) {
                      @case (true) {
                        <span>
                          @if (auctionItem.firstDay) {
                            <app-tooltip
                              [tooltip]="{ title: convert('sellModule.details.auctionDetail.tooltipTimeIndicator.title'), body: convert('sellModule.details.auctionDetail.tooltipTimeIndicator.body') }"
                              triggers="click :keydown.escape :keydown.tab">
                              <div class="tooltip-letter bg-dark text-white"
                                [attr.aria-label]="convert('sellModule.details.auctionDetail.tooltipTimeIndicator.ariaLabelFirstDay')">
                                <span aria-hidden="true">F</span>
                              </div>
                            </app-tooltip>
                          }
                        </span>
                      }
                      @case (false) {
                        <span>
                          @if (auctionItem.firstDay) {
                            <app-tooltip
                              [tooltip]="{ title: convert('sellModule.details.auctionDetail.tooltipTimeIndicator.title'), body: convert('sellModule.details.auctionDetail.tooltipTimeIndicator.body') }"
                              triggers="click hover :keydown.escape :keydown.tab">
                              <div class="tooltip-letter bg-dark text-white"
                                [attr.aria-label]="convert('sellModule.details.auctionDetail.tooltipTimeIndicator.ariaLabelFirstDay')">
                                <span aria-hidden="true">F</span>
                              </div>
                            </app-tooltip>
                          }
                        </span>
                      }
                      @default {
                        <span>
                          @if (auctionItem.firstDay) {
                            <app-tooltip
                              [tooltip]="{ title: convert('sellModule.details.auctionDetail.tooltipTimeIndicator.title'), body: convert('sellModule.details.auctionDetail.tooltipTimeIndicator.body') }"
                              triggers="click hover :keydown.escape :keydown.tab">
                              <div class="tooltip-letter bg-dark text-white"
                                [attr.aria-label]="convert('sellModule.details.auctionDetail.tooltipTimeIndicator.ariaLabelFirstDay')">
                                <span aria-hidden="true">F</span>
                              </div>
                            </app-tooltip>
                          }
                        </span>
                      }
                    }
                  </span>
                </app-datalist-item>
              }
            </li>
          }
          @if (soldVehicle) {
            <li class="m-0">
              <app-datalist-item label="{{convert('sellModule.details.auctionDetail.saleDateTime')}}"
                identifier="sold_vdp_sale_date">
                <time class="auction_time">{{ auctionSaleTime }}</time>
              </app-datalist-item>
            </li>
          }
          @if (posteDate$ | async; as postDate) {
            <li class="m-0">
              <app-datalist-item identifier="active_vdp_posted_date"
                label="{{convert('sellModule.details.auctionDetail.posted')}}" value="{{ postDate ? localizeDate(postDate) : 'N/A' }}">
              </app-datalist-item>
            </li>
          }
          @if (!soldVehicle) {
            <li class="m-0">
              <app-datalist-item identifier="active_vdp_high_bidder_name"
                label="{{convert('sellModule.details.auctionDetail.highBidder')}}"
                value="{{ auctionItem.leadBidderName ? auctionItem.leadBidderName : 'N/A' }}">
              </app-datalist-item>
            </li>
            <li class="m-0">
              @if (auctionItem.buyNowAmount && auctionItem.buyNowEligible) {
                <app-datalist-item label="{{ convert('common.labelBuyNowPrice') }}"
                  value="{{ formatCurrency(auctionItem.buyNowAmount) }}">
                </app-datalist-item>
              } @else {
                <app-datalist-item label="{{ convert('common.labelBuyNowPrice') }}" value="N/A"></app-datalist-item>
              }
            </li>
            <li class="m-0">
              <app-datalist-item label="{{convert('sellModule.details.auctionDetail.offers')}}"><a
                data-track-elem="button" data-track-name="View Offers" attr.aria-label="Offers, {{ auctionItem.openOfferCount }} offer{{
                auctionItem.openOfferCount !== 1 ? 's' : ''
              }}" routerLink="/inventory/{{ auctionItem.inventoryItemUuid }}/offers" class="viewOffers">{{
              auctionItem.openOfferCount }}</a></app-datalist-item>
            </li>
          }
          <li class="m-0">
            <!-- <app-datalist-item label="MSRP" value="${{ auctionItem.msrp | number: '1.0-0' }}"> </app-datalist-item> -->
            @if (auctionItem.msrp) {
              <app-datalist-item label="{{convert('sellModule.details.auctionDetail.msrp')}}"
              value="{{ formatCurrency(msrp) }}"> </app-datalist-item>
            } @else {
              <app-datalist-item label="{{convert('sellModule.details.auctionDetail.msrp')}}" value="N/A">
              </app-datalist-item>
            }
          </li>
          <li class="m-0">
            @if (isTenantBadgeEnabled) {
              <app-datalist-item identifier="active_vdp_tenant_badge"
                label="{{convert('sellModule.details.auctionDetail.tenantBadge')}}"
                value="{{ auctionItem.auctionTenant }}">
              </app-datalist-item>
            }
          </li>
          <li class="m-0">
            @if (!isOfferListsTooltipBodyEmpty ) {
              <span class="part-of-shared-list">
                <img class="icon-warning-filled-orange"
                  src="assets/icons/icon-warning-filled/icon-warning-filled-orange.svg" alt="Warning Icon">
                  {{ translations.partOf }}
                  <app-tooltip [showToolTipAsHtml]="true" [tooltip]="offerListsTooltip" class="hover-tooltip"
                    triggers="click :keydown.escape">
                  <span [id]="'shared-link-hover'" class="shared-text text-bold">
                    {{ currentListType }}
                  </span>
                </app-tooltip>
              </span>
            }
          </li>
          <li>
            @if (isLegacyVDPLinkEnabled) {
              <button id="auction_info_redirect_to_legacy_vdp" class="btn btn-link"
                [attr.aria-label]="convert('sellModule.details.auctionDetail.redirectVDP')" type="button"
                (click)="redirectToLegacyVDP()" data-track-elem="button" data-track-name="Back to Legacy VDP">
                {{ convert('sellModule.details.auctionDetail.backVDP') }}
              </button>
            }
          </li>
        </ul>
      </div>
    </div>
  }
</ng-container>
